import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { AddButton, SmallScreenModel } from "components";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { TableColumns } from "./components/TableColumns";
import { fetchMembershipPlan } from "../store/action";
import HandleCreateMembershipPlan from "./manage_membership_plan/HandleCreateMembershipPlan";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';
import ServerTable from "components/table/ServerTable";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const CommercialMembershipPlanTable: React.FC<Props> = ({
  onFetchMembershipPlan,
  fetchCommercialMembershipPlan,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => setModalOpen(false);
  const openModal = () => setModalOpen(true);
  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0)
  const [hasNext] = useState(true);
  const [pageIndex, setPageIndex] = useState(0); 
  useEffect(() => {
    onFetchMembershipPlan(limit, offset);
  }, [onFetchMembershipPlan, limit, offset]);

  const handlePaginationChange = (newLimit: number, newOffset: number) => {
  const newPageIndex = Math.floor(newOffset / newLimit);
  setLimit(newLimit);
  setOffset(newOffset);
  setPageIndex(newPageIndex);
  onFetchMembershipPlan(newLimit, newOffset);
};
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_COMMERCIAL_MEMBERSHIP));
  return (
    <div className="">
      <ServerTable
        headers={["Membership Plan", "Commercial Membership Plan"]}
        data={fetchCommercialMembershipPlan.membershipPlan}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <>
            {isPermitted && (
              <AddButton
                onClick={openModal}
                label="Add Membership Plan"
                tooltip="Add new membership plan"
              />
            )}
          </>
        }
        onPaginationChange={handlePaginationChange} 
        pageIndex={pageIndex}
        pageSize={limit}   
        hasNext={hasNext} 
      />
      <SmallScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <div className="text-center">
          <HandleCreateMembershipPlan closeModal={closeModal} />
        </div>
      </SmallScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    fetchCommercialMembershipPlan:
      state.membershipPlan?.fetchmembershiPlanState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchMembershipPlan: (limit: number, offset: number) => dispatch(fetchMembershipPlan(limit, offset)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommercialMembershipPlanTable);
